import React, { type ReactElement } from 'react';

import Image from 'next/image';

import useIsNativeApps from '@accounts/hooks/useIsNativeApps';

import Container from '@components/layout/Container/Container';

import swissMadeSoftware from '@static/node/images/illustrations/swiss-made-software.png';

import FooterLinks from './FooterLinks/FooterLinks';
import NativeAppsFooter from './NativeAppsFooter/NativeAppsFooter';
import NativeAppsLinks from './NativeAppsLinks/NativeAppsLinks';

import styles from './Footer.module.scss';

const Footer = (): ReactElement => {
    const isNativeApps = useIsNativeApps();

    if (isNativeApps) {
        return <NativeAppsFooter />;
    }

    return (
        <footer className={styles.container}>
            <Container>
                <div className={styles.content}>
                    <div className={styles.links}>
                        <FooterLinks />
                    </div>
                    <div className={styles.nativeApps}>
                        <NativeAppsLinks />
                        <div className={styles.swissMadeSoftware}>
                            <Image
                                src={swissMadeSoftware}
                                alt="Swiss Made Software"
                                layout="fill"
                            />
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
